export default __webpack_public_path__ + "static/media/rambo.33239119.jpg";